// utils/offlineStorage/ttl.ts - utils/offlineStorage.ts split (sub-module ttl)



// Cache TTL configurations (in milliseconds)
// Increased to reduce Supabase load and handle downtime better
export const CACHE_TTL = {
  ORDERS: 1000 * 60 * 5,         // 5 minutes - changes frequently
  FORMS: 1000 * 60 * 5,          // 5 minutes (was 2hr) - must be fresh for role filter
  USERS: 1000 * 60 * 5,          // 5 minutes (was 2hr) - must be fresh for assignedBrandIds
  SETTINGS: 1000 * 60 * 60 * 4,  // 4 hours - very stable
  DASHBOARD: 1000 * 60 * 5,      // 5 minutes - real-time stats
  BRANDS: 1000 * 60 * 60 * 4,    // 4 hours - very stable
  DEFAULT: 1000 * 60 * 5,        // 5 minutes - default fallback
};
